export default class ProductTabs {
	wrapper: HTMLElement;
	buttons: HTMLElement[];
	panels: HTMLElement[];

	activePanel: HTMLElement;
	activeButton: HTMLElement;

	constructor(tabWrapper:HTMLElement) {
		this.wrapper = tabWrapper;
		this.buttons = Array.from(this.wrapper.querySelectorAll("a[data-product-tab]")) as HTMLElement[];
		this.panels = Array.from(this.wrapper.querySelectorAll("section[data-product-tab]")) as HTMLElement[];

		this.attachEvents();
	}

	attachEvents() {
		for(const button of this.buttons) {
			button.addEventListener("click", (e) => {
				e.preventDefault();
				this.changePanel(e.srcElement.getAttribute("data-product-tab"));
			});
		}
	}

	changePanel(tabId:string) {
		for(const panel of this.panels) {
			panel.removeAttribute("data-status");
		}
		this.activePanel = <HTMLElement>this.wrapper.querySelector('section[data-product-tab="'+tabId+'"]');
		this.activePanel.setAttribute("data-status", "active");

		for(const button of this.buttons) {
			button.removeAttribute("data-status");
		}
		this.activeButton = <HTMLElement>this.wrapper.querySelector('a[data-product-tab="'+tabId+'"]');
		this.activeButton.setAttribute("data-status", "active");
	}
}